import BigNumber from 'bignumber.js';

import type { Token } from 'types';
import { buffer, convertMantissaToTokens, convertTokensToMantissa } from 'utilities';

import { RAO_WEI, floorToRao } from '../../shared/routerSlippage';

// Wallet balance a native router full repay must cover, expressed in the
// native source token. Mirrors useRouterRepayQueue.execute exactly so form
// validation rejects what the router would revert on:
//   - native alpha: buffer({ amountMantissa }) only.
//   - native TAO: buffer, then floorToRao, then the +1 RAO bump applied when
//     the RAO floor swallowed the sub-RAO buffer (repayTAO sends this as
//     msg.value). floorToRao operates on wei, so the RAO path is only correct
//     for 18-decimal native TAO.
export const getFullRepayWalletRequirementTokens = ({
  nativeDebtTokens,
  nativeToken,
  appliesRaoFloor,
}: {
  nativeDebtTokens: BigNumber;
  nativeToken: Token;
  appliesRaoFloor: boolean;
}): BigNumber => {
  const amountMantissa = BigInt(
    convertTokensToMantissa({ value: nativeDebtTokens, token: nativeToken }).toFixed(),
  );

  if (!appliesRaoFloor) {
    return convertMantissaToTokens({
      value: new BigNumber(buffer({ amountMantissa }).toString()),
      token: nativeToken,
    });
  }

  let effectiveAmount = floorToRao(buffer({ amountMantissa }));
  if (effectiveAmount <= floorToRao(amountMantissa)) {
    effectiveAmount = floorToRao(amountMantissa) + RAO_WEI;
  }

  return convertMantissaToTokens({
    value: new BigNumber(effectiveAmount.toString()),
    token: nativeToken,
  });
};
